module.exports = __webpack_public_path__ + "static/media/user3.bd780a29.jpg";